var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("multiselect", {
        class: {
          form__control: true,
          "form__control--invalid": _vm.errors.first(this.name),
        },
        attrs: {
          options: _vm.options,
          placeholder: _vm.placeholder,
          "allow-empty": _vm.allowEmpty,
          label: "label",
          "track-by": "id",
          multiple: _vm.multiple,
          searchable: false,
          "show-labels": false,
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "form__label" }, [_vm._v("Deal Type")]),
      _vm._v(" "),
      this.selected || (this.selected && this.selected.length > 0)
        ? _c(
            "a",
            {
              staticClass: "form__clear",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.clearValue.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            Clear\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form__validation" }, [
        _vm._v(_vm._s(_vm.errors.first(this.name))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }